<div class="admin-shared-page-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="header-container">
        <div class="row-btn" *ngIf="!isHiddenButton">
            <label class="title">{{name}}</label>
            <button class="btn" (click)="onClick($event)" tam-button [tamType]="'primary'" *ngIf="!isWebsites"
                [disabled]="isButtonDisabled">{{btnTitleShared}}
            </button>
            <tam-split-button class="btn" [config]="splitButtonConfig" *ngIf="isWebsites">
            </tam-split-button>
        </div>
    </div>
    <div class="grid-wrapper" [ngClass]="{'grid-with-notes':isShowNotes, 'grid-no-notes':!isShowNotes}">
        <div class="no-data" [style.display]="noDataStyle">
            <span>No Data Found</span>
        </div>
        <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
            [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        <div class="notes" *ngIf="isShowNotes">
            {{notes}}
        </div>
    </div>
</div>